'use strict';

export default function f($http, utils) {
  'ngInject';

  return {
    receivedMessage: null,

    getMessage(userId, visitorId) {
      return $http.get(utils.getApiUrlV2(`offer_texts/${userId}/${visitorId}`));
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/components/trips/trips/send_offer_modal/offer_message.js